if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          viewer: '[id^="GalleryViewer"]',
          thumbnails: '[id^="GalleryThumbnails"]',
          mediaList: '[id^="Slider-Gallery"]',
          mediaItems: ['.product__media-item'],
        };

        this.sliderInstance = false;
        this.thumbsInstance = false;
      }

      connectedCallback() {
        // this.init();
        FoxTheme.Motion.inView(this, this.init.bind(this));
      }

      init() {
        if (this.initialized === true) return;
        this.initialized = true;
        this.elements = window.FoxTheme.utils.queryDomNodes(this.selectors, this);
        this.mediaLayout = this.dataset.mediaLayout;
        this.onlyImage = this.dataset.onlyImage === 'true';
        this.enableDesktopSlider = this.dataset.enableDesktopSlider === 'true';
        this.enableMobileThumbnails = this.dataset.enableMobileThumbnails === 'true';
        this.enableImageZoom = this.dataset.enableImageZoom === 'true';
        this.setSliderOptions();

        // Save original slides for dynamic filtering
        if (this.elements.mediaList) {
          this.originalMediaSlides = Array.from(this.elements.mediaList.children);
        }
        if (this.elements.thumbnails) {
          const thumbnailList = this.elements.thumbnails.querySelector('.thumbnail-list');
          if (thumbnailList) {
            this.originalThumbnailSlides = Array.from(thumbnailList.children);
          }
        }

        const variantsJsonEl = this.querySelector('[id^="ProductVariants"]');
        if (variantsJsonEl) {
          this.productVariants = JSON.parse(variantsJsonEl.textContent);
        }

        const selectedVariantId = this.dataset.selectedVariantId;
        if (selectedVariantId && this.productVariants) {
          const selectedVariant = this.productVariants.find(v => v.id === Number(selectedVariantId));
          if (selectedVariant) {
            this.filterMedia(selectedVariant, true);
          }
        }

        // Warm browser cache for all variant featured images so switching is instant
        if (this.productVariants) {
          const seenIds = new Set();
          this.productVariants.forEach(v => {
            if (v.featured_media && v.featured_media.preview_image && !seenIds.has(v.featured_media.id)) {
              seenIds.add(v.featured_media.id);
              const img = new Image();
              img.src = v.featured_media.preview_image.src;
            }
          });
        }

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.updateMediaLayout.bind(this);
        this.updateMediaLayout();

        if (this.enableImageZoom) {
          const allMedia = [...this.querySelectorAll('.product__media-item:not(.swiper-slide-duplicate)')];
          this.initImageZoom(allMedia);
        }
      }

      setSliderOptions() {
        const mediaItemGap = parseInt(this.dataset.mediaItemGap);

        this.sliderOptions = {
          init: false,
          slidesPerView: '1',
          spaceBetween: mediaItemGap,
          loop: false,
          grabCursor: true,
          allowTouchMove: true,
          autoHeight: true,
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
            type: 'fraction',
          },
          threshold: 2,
        };

        this.thumbsOptions = {
          slidesPerView: 4,
          breakpoints: {
            461: {
              slidesPerView: 5,
            },
          },
          spaceBetween: mediaItemGap,
          loop: false,
          freeMode: true,
          watchSlidesProgress: true,
          threshold: 2,
        };

        switch (this.mediaLayout) {
          case 'vertical-carousel':
            this.thumbsOptions = Object.assign({}, this.thumbsOptions, {
              breakpoints: {
                768: {
                  direction: 'vertical',
                  slidesPerView: 'auto',
                },
              },
            });
            break;
          case 'slider-freemode':
            this.sliderOptions = Object.assign({}, this.sliderOptions, {
              slidesPerView: 'auto',
            });
            break;
        }
      }

      updateMediaLayout() {
        if (FoxTheme.config.mqlMobile) {
          this.initSlider();
        } else {
          if (this.enableDesktopSlider) {
            this.initSlider();
          } else {
            this.destroySlider();
          }
        }
      }

      initSlider() {
        if (typeof this.sliderInstance !== 'object') {
          if ((this.enableDesktopSlider || this.enableMobileThumbnails) && this.elements.thumbnails) {
            this.thumbsInstance = new window.FoxTheme.Carousel(this.elements.thumbnails, this.thumbsOptions);
            this.thumbsInstance.init();

            this.sliderOptions.thumbs = {
              swiper: this.thumbsInstance.slider,
              autoScrollOffset: 2,
            };
          }

          this.sliderInstance = new window.FoxTheme.Carousel(this.elements.viewer, this.sliderOptions, [
            FoxTheme.Swiper.Thumbs,
          ]);
          this.sliderInstance.init();

          this.handleSliderAfterInit();
          this.handleSlideChange();

          this.sliderInstance.slider.init();
        }
      }

      destroySlider() {
        if (typeof this.sliderInstance === 'object') {
          this.sliderInstance.slider.destroy();
          this.sliderInstance = false;
        }
      }

      initThumbsSlider() {
        if (typeof this.thumbsInstance !== 'object') {
          this.thumbsInstance = new window.FoxTheme.Carousel(this.selectors.thumbnails, this.thumbsOptions);
          this.thumbsInstance.init();
        }
      }

      initImageZoom(items = []) {
        let dataSource = [];
        if (items.length > 0) {
          items.forEach((media) => {
            switch (media.dataset.mediaType) {
              case 'model':
                dataSource.push({
                  id: media.dataset.mediaIndex,
                  html: `<div class="pswp__item--${media.dataset.mediaType}">${
                    media.querySelector('product-model').outerHTML
                  }</div>`,
                  mediaType: media.dataset.mediaType,
                });
                break;
              case 'video':
              case 'external_video':
                dataSource.push({
                  id: media.dataset.mediaIndex,
                  html: `<div class="pswp__item--${media.dataset.mediaType}">${
                    media.querySelector('video-element').outerHTML
                  }</div>`,
                  mediaType: media.dataset.mediaType,
                });
                break;
              case 'image':
                dataSource.push({
                  id: media.dataset.mediaIndex,
                  src: media.dataset.src,
                  width: media.dataset.pswpWidth,
                  height: media.dataset.pswpHeight,
                  mediaType: media.dataset.mediaType,
                });
                break;
            }
          });
        }

        this.lightbox = new window.FoxTheme.PhotoSwipeLightbox({
          dataSource: dataSource,
          pswpModule: window.FoxTheme.PhotoSwipe,
          bgOpacity: 1,
          arrowPrev: false,
          arrowNext: false,
          zoom: false,
          close: false,
          counter: false,
          preloader: false,
          preload: [1, 4],
        });

        this.lightbox.addFilter('thumbEl', (thumbEl, { id }, index) => {
          if (this.sliderInstance && this.sliderInstance.slider) {
            const { slides, activeIndex } = this.sliderInstance.slider;
            if (slides[activeIndex]) {
              const el = slides[activeIndex].querySelector('img');
              if (el) {
                return el;
              }
            }
          }

          return thumbEl;
        });

        this.lightbox.addFilter('placeholderSrc', (placeholderSrc, { data }) => {
          if (data.src) {
            return data.src;
          }
          return placeholderSrc;
        });

        this.lightbox.on('change', () => {
          window.pauseAllMedia(this);
        });

        this.lightbox.on('destroy', () => {
          const { currIndex } = this.lightbox.pswp;

          if (this.sliderInstance && this.sliderInstance.slider) {
            this.sliderInstance.slider.slideToLoop(currIndex, 0, false);
          }
        });

        this.lightbox.on('pointerDown', (e) => {
          if (this.lightbox.pswp.currSlide.data.mediaType != 'image') {
            e.preventDefault();
          }
        });

        this.lightbox.on('uiRegister', () => {
          if (!this.onlyImage) {
            this.lightbox.pswp.ui.registerElement({
              name: 'next',
              ariaLabel: 'Next slide',
              order: 3,
              isButton: true,
              html: '<svg class="pswp-icon-next flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
              onClick: (event, el) => {
                this.lightbox.pswp.next();
              },
            });
            this.lightbox.pswp.ui.registerElement({
              name: 'prev',
              ariaLabel: 'Previous slide',
              order: 1,
              isButton: true,
              html: '<svg class="pswp-icon-prev rtl-flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
              onClick: (event, el) => {
                this.lightbox.pswp.prev();
              },
            });
          }
          this.lightbox.pswp.ui.registerElement({
            name: 'close-zoom',
            ariaLabel: 'Close zoom image',
            order: 2,
            isButton: true,
            html: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
            onClick: (event, el) => {
              this.lightbox.pswp.close();
            },
          });
        });

        this.lightbox.init();

        FoxTheme.utils.addEventDelegate({
          selector: '.js-photoswipe--zoom',
          context: this,
          handler: (e, media) => {
            if (media.dataset.mediaType === 'image') {
              const index = Number(media.dataset.mediaIndex) || 0;
              this.lightbox.loadAndOpen(index);
            }
          },
        });
      }

      handleSliderAfterInit() {
        this.sliderInstance.slider.on('afterInit', (swiper) => {
          const { slides, activeIndex } = swiper;

          if (slides[activeIndex]) {
            const isModelMediaType = slides[activeIndex].dataset.mediaType === 'model';
            this.toggleSliderDraggableState(!isModelMediaType);
          }
        });
      }

      handleSlideChange() {
        this.sliderInstance.slider.on('realIndexChange', (swiper) => {
          const { slides, activeIndex, thumbs } = swiper;

          if (thumbs.swiper) {
            thumbs.swiper.slideTo(activeIndex);
          }

          if (slides[activeIndex]) {
            this.playActiveMedia(slides[activeIndex]);

            const isModelMediaType = slides[activeIndex].dataset.mediaType === 'model';
            this.toggleSliderDraggableState(!isModelMediaType);
          }
        });
      }

      toggleSliderDraggableState(isDraggable) {
        if (this.sliderInstance.slider.allowTouchMove !== isDraggable) {
          this.sliderInstance.slider.allowTouchMove = isDraggable;
        }
      }

      playActiveMedia(selected) {
        const deferredMedia = selected.querySelector('product-model');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      setActiveMedia(variant, isInitial = false) {
        if (!variant) return;
        this.filterMedia(variant, isInitial);
      }

      filterMedia(variant, isInitial = false) {
        if (!variant) return;
        // Guard against being called before init() has populated this.elements (e.g. gallery not yet in view).
        if (!this.elements) return;

        // 1. Destroy current sliders (if not initial loading)
        if (!isInitial) {
          this.destroySlider();
          if (typeof this.thumbsInstance === 'object') {
            this.thumbsInstance.slider.destroy();
            this.thumbsInstance = false;
          }
        }

        // 2. Prepare option values for filtering
        const selectedValues = variant.options.map(val => val.toLowerCase().trim());
        
        // Build all possible option values across all variants
        if (!this.allOptionValues) {
          this.allOptionValues = new Set();
          if (this.productVariants) {
            this.productVariants.forEach(v => {
              v.options.forEach(opt => {
                this.allOptionValues.add(opt.toLowerCase().trim());
              });
            });
          }
        }

        const productTitleLower = (this.dataset.productTitle || '').toLowerCase().trim();

        // Check if there is at least one media specifically matching this variant's options or featured media ID
        const hasVariantImages = !!variant.featured_media || (this.originalMediaSlides && this.originalMediaSlides.some(slide => {
          const mediaAlt = slide.dataset.mediaAlt || '';
          const altNormalized = mediaAlt.toLowerCase().trim();
          
          if (altNormalized === '' || altNormalized === productTitleLower) return false;
          
          const altParts = altNormalized.split(/[\s\-\,\/]+/);
          const isVariantSpecific = altParts.some(part => this.allOptionValues.has(part)) || this.allOptionValues.has(altNormalized);
          if (!isVariantSpecific) return false;
          
          return selectedValues.some(val => altNormalized.includes(val) || val.includes(altNormalized));
        }));

        // 3. Filter media slides
        let filteredMediaSlides = [];
        if (this.originalMediaSlides) {
          if (hasVariantImages) {
            filteredMediaSlides = this.originalMediaSlides.filter(slide => {
              const mediaAlt = slide.dataset.mediaAlt || '';
              const altNormalized = mediaAlt.toLowerCase().trim();
              
              // General images: blank, matching product title, or not in the variants options list
              if (altNormalized === '' || altNormalized === productTitleLower) return true;
              
              const altParts = altNormalized.split(/[\s\-\,\/]+/);
              const isVariantSpecific = altParts.some(part => this.allOptionValues.has(part)) || this.allOptionValues.has(altNormalized);
              
              if (!isVariantSpecific) return true;
              
              // Variant-specific images: must match at least one selected option value or the variant's featured media ID
              const matchesOption = selectedValues.some(val => altNormalized.includes(val) || val.includes(altNormalized));
              const matchesFeaturedId = variant.featured_media && (slide.dataset.mediaId == variant.featured_media.id);
              return matchesOption || matchesFeaturedId;
            });
          } else {
            filteredMediaSlides = [...this.originalMediaSlides];
          }
        }

        // 4. Filter thumbnail slides
        let filteredThumbnailSlides = [];
        if (this.originalThumbnailSlides) {
          if (hasVariantImages) {
            filteredThumbnailSlides = this.originalThumbnailSlides.filter(slide => {
              const mediaAlt = slide.dataset.mediaAlt || '';
              const altNormalized = mediaAlt.toLowerCase().trim();
              
              if (altNormalized === '' || altNormalized === productTitleLower) return true;
              
              const altParts = altNormalized.split(/[\s\-\,\/]+/);
              const isVariantSpecific = altParts.some(part => this.allOptionValues.has(part)) || this.allOptionValues.has(altNormalized);
              
              if (!isVariantSpecific) return true;
              
              const matchesOption = selectedValues.some(val => altNormalized.includes(val) || val.includes(altNormalized));
              const matchesFeaturedId = variant.featured_media && (slide.dataset.mediaId == variant.featured_media.id);
              return matchesOption || matchesFeaturedId;
            });
          } else {
            filteredThumbnailSlides = [...this.originalThumbnailSlides];
          }
        }

        // 5. Move featured media to first position (keep media list and thumbnail list in the same
        // order — the thumbs Swiper syncs to the main slider by index, not by media id, so any
        // divergence here makes the "active" thumbnail highlight a different image than the one shown).
        // Skipped on initial page load so the gallery keeps the merchant's actual Media order instead
        // of jumping to the default variant's featured image before the shopper has touched anything.
        if (!isInitial && variant.featured_media && filteredMediaSlides.length > 1) {
          const featuredIdx = filteredMediaSlides.findIndex(s => s.dataset.mediaId == variant.featured_media.id);
          if (featuredIdx > 0) {
            const [featured] = filteredMediaSlides.splice(featuredIdx, 1);
            filteredMediaSlides.unshift(featured);
          }
        }
        if (!isInitial && variant.featured_media && filteredThumbnailSlides.length > 1) {
          const featuredThumbIdx = filteredThumbnailSlides.findIndex(s => s.dataset.mediaId == variant.featured_media.id);
          if (featuredThumbIdx > 0) {
            const [featuredThumb] = filteredThumbnailSlides.splice(featuredThumbIdx, 1);
            filteredThumbnailSlides.unshift(featuredThumb);
          }
        }

        // 6. Update the DOM — move nodes in-place to preserve image-lazy state
        if (this.elements.mediaList) {
          filteredMediaSlides.forEach((slide, index) => {
            slide.setAttribute('data-media-index', index);
            if (slide.querySelector('.js-photoswipe--zoom')) {
              slide.querySelector('.js-photoswipe--zoom').setAttribute('data-media-index', index);
            }
            this.elements.mediaList.appendChild(slide);
          });
          // Remove slides not in the filtered set
          this.originalMediaSlides.forEach(slide => {
            if (!filteredMediaSlides.includes(slide) && slide.parentNode === this.elements.mediaList) {
              this.elements.mediaList.removeChild(slide);
            }
          });
        }

        if (this.elements.thumbnails) {
          const thumbnailList = this.elements.thumbnails.querySelector('.thumbnail-list');
          if (thumbnailList) {
            thumbnailList.innerHTML = '';
            filteredThumbnailSlides.forEach((slide, index) => {
              slide.setAttribute('data-media-position', index + 1);
              thumbnailList.appendChild(slide);
            });
          }
        }

        // 6. Handle showing/hiding controls if count <= 1
        const controls = this.querySelector('.slider-controls--group');
        if (controls) {
          if (filteredMediaSlides.length > 1) {
            controls.classList.remove('md:hidden');
            controls.style.display = '';
          } else {
            controls.classList.add('md:hidden');
            controls.style.display = 'none';
          }
        }

        // 7. Update thumbnails container visibility if <= 1 slide
        if (this.elements.thumbnails) {
          if (filteredThumbnailSlides.length > 1) {
            this.elements.thumbnails.classList.remove('hidden');
            this.elements.thumbnails.style.display = '';
          } else {
            this.elements.thumbnails.classList.add('hidden');
            this.elements.thumbnails.style.display = 'none';
          }
        }

        // 8. Re-initialize image zoom and Swiper instances (if not initial loading)
        if (!isInitial) {
          const stickyHeader = document.querySelector('sticky-header') || document.querySelector('header');
          const headerHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
          const galleryTop = this.getBoundingClientRect().top + window.scrollY - headerHeight;
          window.scrollTo({ top: galleryTop, behavior: 'smooth' });

          if (this.enableImageZoom) {
            const allMedia = [...this.querySelectorAll('.product__media-item:not(.swiper-slide-duplicate)')];
            this.initImageZoom(allMedia);
          }
          this.updateMediaLayout();

          // 9. Slide to featured image if available
          if (this.sliderInstance && this.sliderInstance.slider) {
            const featuredMediaId = variant.featured_media ? variant.featured_media.id : null;
            if (featuredMediaId) {
              const newSlides = Array.from(this.elements.mediaList.children);
              const slideIndex = newSlides.findIndex(slide => slide.dataset.mediaId == featuredMediaId);
              if (slideIndex !== -1) {
                this.sliderInstance.slider.slideTo(slideIndex, 0, false);
              }
            }
          }
        }
      }
    }
  );
}
